























































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import Carregando from '../../components/Carregando.vue';
import TheInternacoesTabelaAgendadas from '../../components/internacoes/TheInternacoesTabelaAgendadas.vue';
import TheInternacoesTabelaAtivas from '../../components/internacoes/TheInternacoesTabelaAtivas.vue';
import TheInternacoesTabelaFinalizadas from '../../components/internacoes/TheInternacoesTabelaFinalizadas.vue';
import { Internacao } from '../../../../back/src/entity/Internacao';


export default Vue.extend({
  name: 'InternacoesIndex',
  components: {
    Carregando,
    TheInternacoesTabelaAgendadas,
    TheInternacoesTabelaAtivas,
    TheInternacoesTabelaFinalizadas,
  },
  data: () => ({
    loading: {
      internacoesAtivas: true,
    },
    tab: 0,
    internacoesAtivas: [],
  }),
  computed: {
    temInternacoesAtivas() {
      return !_.isEmpty(this.internacoesAgrupadas);
    },
    internacoesAgendadas() {
      return _.filter(
        this.internacoesAtivas as Internacao[],
        internacao => (internacao.datetime_agendamento && !internacao.datetime_internacao),
      );
    },
  },
  mounted() {
    this.getInternacoesAtivas();
  },
  methods: {
    altaConfirmada(internacao: Internacao) {
      const index = _.findIndex(
        this.internacoesAtivas as Internacao[],
        item => item.id === internacao.id,
      );
      if (index >= 0) {
        this.$delete(this.internacoesAtivas, index);
      }
    },
    async getInternacoesAtivas() {
      this.loading.internacoesAtivas = true;
      try {
        const response = await Requester.internacao.buscaInternacoesAtivas();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'Home' });
        } else {
          this.internacoesAtivas = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.internacoesAtivas = false;
      }
    },
  },
});
